import {setToken} from "@/libs/util";

let config = {
    apiBaseUrl: {
        // dev: 'http://123.207.75.179:8126',// 测试环境api
        dev: 'http://192.168.31.140:8126',
        // pro: 'https://api.duopei.feiniaowangluo.com',
        pro: 'https://api.duopei.feiniaowangluo.com'

    },
    sid: null
};
if (process.env.NODE_ENV === 'development') {
    config.sid = 1
    setToken('dev')
}
export default config;

export const getApiBaseUrl = () => {
    // if (window.location.host.includes('peipei.featnet.com')) {
    //     return 'http://api.peipei.featnet.com'
    // }
    // return process.env.NODE_ENV === 'development' ? config.apiBaseUrl.dev : config.apiBaseUrl.pro
    return process.env.NODE_ENV === 'development' ?
        config.apiBaseUrl.dev :
        config.apiBaseUrl.pro
}
